import { stringify } from 'qs';
import request from '@/utils/request';

export async function qryBrowserLogList(param) {
  return request('/browser/logs', {
    method: 'POST',
    body: param,
  });
}

export async function queryLogCount() {
  return request('/browser/log/count');
}

export async function qryPortals() {
  return request('/portals');
}

export async function qryUsers(params) {
  return request(`/users?${stringify(params)}`);
}
